import { PUT_AUDIO_TRACKS } from "../constants/actionTypes";

export function putAudioTracks(audioTracks) {
    return {
        type: PUT_AUDIO_TRACKS,
        payload: audioTracks
    };
}
